import * as styledComponents from 'styled-components';

/* tslint:disable */
// styledComponents.ThemedStyledComponentsModule<any>
const {
    default: styled,
    css,
    injectGlobal,
    keyframes,
} = styledComponents as styledComponents.ThemedStyledComponentsModule<any>;
const { ThemeProvider } = styledComponents as any;
/* tslint:enable */

const defaultButtonStyle = {
    background: '#121419',
    border: '0',
    borderRadius: '0',
    boxShadow: 'none',
    color: '#fff',
    fontWeight: '600',
    fontSize: '14px',
    margin: '0',
    opacity: '1',
    padding: '5px 8px',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
    hover: {
        background: '#232832',
    },
};

const defaultOutlineButtonStyle = {
    background: 'transparent',
    borderColor: '#333',
    borderWidth: '1px',
    borderRadius: '0',
    boxShadow: 'none',
    color: '#333',
    fontWeight: '600',
    fontSize: '14px',
    margin: '0',
    opacity: '1',
    padding: '5px 8px',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
    hover: {
        border: '1xp solid #232832',
    },
};

const defaultLinkStyle = {
    background: 'transparent',
    border: '0',
    borderRadius: '0',
    boxShadow: 'none',
    color: '#232832',
    fontWeight: '400',
    fontSize: '14px',
    margin: '0',
    opacity: '1',
    padding: '0',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
    hover: {
        color: '#121419',
    },
};

const Theme = {
    background: '#FFFFFF',
    logoBackground: '#40464d',
    sidebarBackground: '#232832',
    loader: 'rgba(28, 134, 164, 0.68)',
    border: '1px solid #28AADC',
    transition: '0.3s cubic-bezier(0.76, 0.03, 0, 0.65)',
    boxShadow: '0 4px 7px 0 rgba(117, 117, 117, 0.15)',
    boxShadowUp: '0 -3px 7px 0 rgba(117, 117, 117, 0.10)',
    headerHeight: '100px',
    sidebarSize: '180px',
    clientColor: '#366bff',
    title: {
        fontWeight: 'bolder',
        fontSize: '48px',
        margin: '0 0 40px 0',
    },
    nav: {
        padding: '10px 30px',
        background: 'transparent',
        backgroundHover: '#121419',
        color: '#ffffff',
        colorHover: '#ffffff',
        textTransform: 'capitalize',
    },
    button: {
        default: {
            ...defaultButtonStyle,
        },
        primary: {
            ...defaultButtonStyle,
            background: '#366bff',
            borderRadius: '8px',
            color: '#fff',
            padding: '15px 40px',
            hover: {
                background: '#2451d0',
            },
        },
        danger: {
            ...defaultButtonStyle,
            background: '#FA5050',
            borderRadius: '8px',
            color: '#fff',
            padding: '15px 40px',
            hover: {
                background: '#d83232',
            },
        },
    },
    outline: {
        default: {
            ...defaultOutlineButtonStyle,
        },
        primary: {
            ...defaultOutlineButtonStyle,
            borderColor: '#366bff',
            borderRadius: '8px',
            color: '#366bff',
            padding: '15px 40px',
            hover: {
                borderColor: '#2451d0',
                color: '#2451d0',
            },
        },
        danger: {
            ...defaultOutlineButtonStyle,
            borderColor: '#FA5050',
            borderRadius: '8px',
            color: '#FA5050',
            padding: '15px 40px',
            hover: {
                borderColor: '#d83232',
                color: '#d83232',
            },
        },
    },
    link: {
        default: {
            ...defaultLinkStyle,
        },
        primary: {
            ...defaultLinkStyle,
            color: '#366bff',
            hover: {
                color: '#2451d0',
            },
        },
        danger: {
            ...defaultLinkStyle,
            color: '#FA5050',
            hover: {
                color: '#d83232',
            },
        },
    },
    form: {
        searchWrapper: {
            border: 0,
            boxShadow: '0 0 10px 0 rgba(117, 117, 117, 0.3)',
        },
        search: {
            border: 0,
            color: '#333',
            fontSize: '14px',
            fontWeight: '400',
            padding: '15px',
            width: '100%',
        },
        inputWrapper: {},
        input: {
            border: '1px solid #ddd',
            borderRadius: '8px',
            color: '#333',
            fontSize: '14px',
            fontWeight: '400',
            padding: '8px 15px',

        },
        inputCheckboxText: {
            border: '1px solid #ddd',
            borderRadius: '5px',
            color: '#333',
            fontSize: '14px',
            fontWeight: '400',
            padding: '8px 15px',
            width: '20%',
        },
        inputnumber: {
            border: '1px solid #ddd',
            borderRadius: '8px',
            color: '#333',
            fontSize: '14px',
            fontWeight: '400',
            padding: '8px 15px',
            width: '38%',
        },

        inputArea: {
            border: '1px solid #ddd',
            borderRadius: '8px',
            color: '#333',
            fontSize: '14px',
            fontWeight: '400',
            padding: '30px 15px',
            width: '100%',
        },
        authWrapper: {
            border: 0,
            boxShadow: 'none',
        },
        auth: {
            background: 'transparent',
            border: 0,
            borderRadius: 0,
            borderBottom: '1px solid #ddd',
            color: '#333',
            fontSize: '14px',
            fontWeight: '400',
            padding: '10px 0',
            width: '100%',
        },
        addornLeft: {},
        addornRight: {
            padding: '10px',
        },
        localeChange: {
            display: {
                padding: '10px 5px',
            },
        },
        upload: {
            background: '#F7F7F7',
            border: '1px solid #ddd !important',
            borderRadius: '8px !important',
            color: '#333',
            fontSize: '14px',
            cursor: 'pointer',
            display: 'block',
            padding: '25px',
            position: 'relative',
            textAlign: 'center',
            height: 'auto !important',
            width: '100% !important',
        },
    },
    modal: {
        background: '#fff',
        borderRadius: '20px',
        boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.115)',
        padding: '30px 40px',
        maxWidth: '500px',
    },
    primary: {
        dark: '#707070',
        light: '#28AADC',
        regular: '#1890ff',
    },
    secondary: {
        dark: '#0C4031',
        light: '#28DCAA',
        regular: '#177F63',
        black: '#000000',
        darkGrey: '#7E7E7E',
        grey: '#7E7E7E',
        midGrey: '#B5B5B5',
        lightGrey: '#DEDEDE',
        supahLightGrey: '#F5F5F5',
        midLightGrey: '#CCCCCC',
        darkWhite: '#FCFCFC',
        white: '#FFFFFF',
        red: '#FA5050',
    },

    standard: {
        black: '#000000',
        gray: '#969696',
        lightGray: '#e0e0e0',
        lightGray2: '#f3f3f3',
        lightGray3: '#b5b5b5',
        green: '#28DCAA',
        orange: '#FF9650',
        red: '#FA5050',
        white: '#FFFFFF',
        yellow: '#FFDB55',
        textColor: '#40464D',
        lineHeight: 1.25,
        font: {
            size: '14px',
            weight: '400',
            family: "'Open Sans', sans-serif",
        },
    },
    status: {
        done: '#28DCAA',
        error: '#FA5050',
        inProgress: '#ffc900',
        overdue: '#FF9650',
        toDo: '#FFFFFF',
    },
    terciary: {
        highlight: '#FB9A2C',
        graph1: '#A2B5EA',
        graph2: '#68D8E2'
    },
    ehssStatus: {
        done: '#b5b5b5',
        error: '#b5b5b5',
        inProgress: '#b5b5b5',
        overdue: '#b5b5b5',
        toDo: '#b5b5b5',
    }
};
const ThemeClient = async () => {
    Theme.nav.backgroundHover = Theme.nav.backgroundHover;
    Theme.clientColor = Theme.clientColor;
    return Theme;
}

export { css, injectGlobal, keyframes, ThemeProvider, Theme, ThemeClient };
export default styled;

